export default {
  common: {
    table: {
      notfound: 'No records found',
    },
    notification: {
      error: 'Error',
      errorMsg: 'There was an error sending the email',
      organizationContact: 'There was an error creating the organization contacts and updating the organization, might be due to duplicate emails',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/common.js